import { render, staticRenderFns } from "./lecturerDetail.vue?vue&type=template&id=5bc38f7a&scoped=true"
import script from "./lecturerDetail.vue?vue&type=script&lang=js"
export * from "./lecturerDetail.vue?vue&type=script&lang=js"
import style0 from "./lecturerDetail.vue?vue&type=style&index=0&id=5bc38f7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc38f7a",
  null
  
)

export default component.exports